import styled from 'styled-components'
import ContainerBase from '../../components/container'
import ButtonBase from '@material-ui/core/ButtonBase'

export const FlexEnd = styled.div`
  display: flex;
  justify-content: flex-end;
`

export const Notify = styled.div`
  width: 450px;
  padding: 30px;
  color: var(--first);
  font-size: 1em;
  font-weight: bold;
  background: #cdcdcd2e;
  margin-top: 20px;
  border-radius: 10px;
  position: relative;
`

export const IconContainer = styled.div`
  position: absolute;
  padding: 2px 16px;
  background: red;
  border-radius: 10px;
  font-size: 25px;
  color: #fff;
  border: 3px solid #fff;
  top: -22px;
  left: -25px;
`

export const Summary = styled.div`
  background: var(--user-gray-light);
  padding: 10px;
  border-radius: 10px;
  width: 450px;
  font-size: 1.3em;
  font-weight: bold;
  text-align: right;
  & span {
    font-weight: normal;
    color: var(--user-gray);
    margin-right: 10px;
  }
  @media screen and (max-width: 400px) {width: 100%}
  @media screen and (max-width: 700px) { 
    font-size: 1.1em;
  }
`

export const BoxForRadio = styled(Summary)`
  background: #fff;
  border: 1px solid gainsboro;
  text-align: left;
  span {
    color: gray;
    font-weight: normal;
    font-size: .9em;
    line-height: 0px;
  }
`

export const Total = styled.div`
  margin-top: 10px;
  background: var(--user-black-light);
  padding: 10px;
  border-radius: 10px;
  width: 450px;
  font-size: 1.3em;
  font-weight: bold;
  text-align: right;
  & span {
    font-weight: normal;
    color: var(--user-gray);
    margin-right: 10px;
  }
  @media screen and (max-width:400px) {width: 100%}
  @media screen and (max-width: 700px) { 
    font-size: 1.1em;
  }
`
export const Container = styled(ContainerBase)`
  max-width: 1000px;
`
export const ButtonContainer = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
`
export const ButtonStyled = styled.div`
  max-width:180px;
  width:100%;
  padding-top: 15px;
  padding-bottom: 15px;
`
export const Button = styled(ButtonBase)`
  width: 48%;
  font-size: 1em;
  padding: 10px 0px;
  border-radius: 5px;
  color: ${props => props.variant === 'contained' ? '#fff' : 'firs'};
  border: ${props => props.variant === 'contained' ? '' : '1px solid var(--first)'};
  background: ${props => props.variant === 'contained' ? 'var(--first)' : 'none'};
  @media screen and (max-width:700px) {
    font-size: 1em;
  }
`
